"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var UpNextExpansion_1 = require("./UpNextExpansion");
var getWeatherImage_1 = require("../utils/getWeatherImage");
var store_1 = require("../store/store");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var toggleAgenda_1 = require("../actions/toggleAgenda");
var toggleExpansion_1 = require("../actions/toggleExpansion");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var owa_strings_1 = require("owa-strings");
var owa_url_1 = require("owa-url");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_datetime_format_1 = require("owa-datetime-format");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var styles = require('./UpNext.scss');
var classNames = require('classnames/bind');
var MINUTE_IN_MILLISECONDS = 60 * 1000;
var FIVE_MINUTES_IN_MILLISECONDS = 5 * MINUTE_IN_MILLISECONDS;
var TWENTY_MINUTES_IN_MILLISECONDS = 20 * MINUTE_IN_MILLISECONDS;
var UpNext = /** @class */ (function (_super) {
    tslib_1.__extends(UpNext, _super);
    function UpNext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpNext.prototype.render = function () {
        var _this = this;
        var meetings = this.props.calendarItems.values();
        var agendaMeetings = [];
        var name;
        var location;
        var time;
        var isMeetingIn5MinRange;
        if (!meetings || meetings.length == 0) {
            name = owa_common_strings_1.default.noEvents;
        }
        else {
            var nextMeeting = void 0;
            var fiveMinutesAgo = this.getFiveMinutesAgoDate();
            for (var _i = 0, meetings_1 = meetings; _i < meetings_1.length; _i++) {
                var meeting = meetings_1[_i];
                agendaMeetings.push({
                    key: meeting.ItemId.Id,
                    name: owa_datetime_format_1.formatShortTime(new Date(meeting.Start)) +
                        ' - ' +
                        meeting.Subject +
                        ' ● ' +
                        meeting.Location.DisplayName,
                });
                if (!nextMeeting && new Date(meeting.Start) > fiveMinutesAgo) {
                    // We found the next meeting.
                    nextMeeting = meeting;
                }
            }
            // Grab the info out of the next meeting.
            if (nextMeeting) {
                name = nextMeeting.Subject;
                location = nextMeeting.Location.DisplayName;
                var now = new Date();
                var meetingStart = new Date(nextMeeting.Start);
                var isTodayMeeting = new Date().toDateString() == meetingStart.toDateString();
                var millisecondsDifference = now.getTime() - meetingStart.getTime();
                if (millisecondsDifference >= 0 &&
                    millisecondsDifference <= FIVE_MINUTES_IN_MILLISECONDS) {
                    time = owa_common_strings_1.default.now;
                }
                else if (millisecondsDifference < 0 &&
                    Math.abs(millisecondsDifference) <= TWENTY_MINUTES_IN_MILLISECONDS) {
                    var minutes = Math.ceil(Math.abs(millisecondsDifference) / MINUTE_IN_MILLISECONDS);
                    time = minutes <= 1 ? owa_common_strings_1.default.inOneMinute : owa_strings_1.format(owa_common_strings_1.default.inXMinutes, minutes);
                }
                else {
                    // Regular time.
                    time = owa_strings_1.format(isTodayMeeting ? owa_common_strings_1.default.todayAt : owa_common_strings_1.default.tomorrowAt, owa_datetime_format_1.formatShortTime(meetingStart));
                }
            }
            else {
                // No next meeting.
                name = owa_common_strings_1.default.noMoreEvents;
            }
        }
        agendaMeetings.push({
            key: 'agendaToCalendar',
            name: owa_common_strings_1.default.goToCalendar,
            icon: "Calendar" /* Calendar */,
            onClick: function () {
                return window.location.assign(owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }));
            },
        });
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.container },
                this.renderWeatherCharms(),
                React.createElement("div", { className: styles.left },
                    React.createElement("span", { className: styles.next }, owa_common_strings_1.default.next),
                    React.createElement("span", { className: styles.name, title: name }, name),
                    React.createElement("span", { className: styles.location, title: location }, location)),
                React.createElement("div", { className: styles.right },
                    React.createElement("span", { className: classNames(isMeetingIn5MinRange && styles.important, styles.time) }, time),
                    React.createElement(Button_1.IconButton, { ref: function (ref) { return (_this.agendaRef = ReactDOM.findDOMNode(ref)); }, onClick: this.toggleAgendaClick, className: styles.agenda, iconProps: { iconName: "Calendar" /* Calendar */ } }),
                    store_1.default.isAgendaOpen && (React.createElement(ContextualMenu_1.ContextualMenu, { shouldFocusOnMount: true, isBeakVisible: true, target: this.agendaRef, gapSpace: 5, directionalHint: 11 /* rightTopEdge */, onDismiss: this.toggleAgendaClick, items: agendaMeetings })))),
            store_1.default.isExpansionOpen && React.createElement(UpNextExpansion_1.default, null)));
    };
    UpNext.prototype.renderWeatherCharms = function () {
        var weatherClasses = classNames(styles.weather, !this.props.isExpansionOpen && styles.withNoExpansion);
        return (this.props.weatherDailyConditions && (React.createElement("a", { className: weatherClasses, href: store_1.default.weatherClickThrough, onClick: this.toggleExpansionClick, target: "_blank" },
            React.createElement("div", { className: styles.weatherInnerContainer }, this.props.weatherDailyConditions.map(function (item, index) {
                var weatherCharmClasses = classNames(styles.weatherIcon, index == 0 ? styles.currentWeather : styles.forecastWeather, getWeatherImage_1.default(item.SkyCode), getWeatherImage_1.default()); // Fallback css image.
                return (React.createElement("i", { key: 'wi' + index, className: weatherCharmClasses, title: item.SkyText }));
            })))));
    };
    UpNext.prototype.toggleExpansionClick = function (ev) {
        toggleExpansion_1.default();
    };
    UpNext.prototype.toggleAgendaClick = function (ev) {
        ev.stopPropagation();
        toggleAgenda_1.default();
    };
    UpNext.prototype.getFiveMinutesAgoDate = function () {
        var fiveMinutesAgo = new Date();
        fiveMinutesAgo.setTime(fiveMinutesAgo.getTime() - FIVE_MINUTES_IN_MILLISECONDS);
        return fiveMinutesAgo;
    };
    UpNext = tslib_1.__decorate([
        react_1.reactive({
            calendarItems: function () { return store_1.default.calendarItems; },
            isAgendaOpen: function () { return store_1.default.isAgendaOpen; },
            isExpansionOpen: function () { return store_1.default.isExpansionOpen; },
            weatherClickThrough: function () { return store_1.default.weatherClickThrough; },
            weatherDailyConditions: function () { return store_1.default.weatherDailyConditions; },
        })
    ], UpNext);
    return UpNext;
}(React.Component));
exports.default = UpNext;
//# sourceMappingURL=UpNext.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/components/UpNext.js
// module id = 4823
// module chunks = 48